module.exports = __webpack_public_path__ + "static/img/contacto.519594d6.jpg";